import React from 'react';
import { Hero } from '../components/Hero';
import { FreeCardSection } from '../components/FreeCardSection';
import { TarotExplanationSection } from '../components/TarotExplanationSection';
import { TarotCardImage } from '../components/TarotCardImage';
import { WhoIsThisFor } from '../components/WhoIsThisFor';
import { EmotionalGuarantee } from '../components/EmotionalGuarantee';
import { PremiumBonusSection } from '../components/PremiumBonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FoolCardImage } from '../components/FoolCardImage';
import { StorySection } from '../components/StorySection';
import { CTASection } from '../components/CTASection';
import { SecretSectionTeaser } from '../components/SecretSectionTeaser';
import { LifestyleImage } from '../components/LifestyleImage';
import { FAQSection } from '../components/FAQSection';
import { SalesNotification } from '../components/SalesNotification';
import { Sparkles } from 'lucide-react';
export function LandingPage() {
  return <div className="min-h-screen bg-[#0C0F17] text-[#F7F5F2] font-sans selection:bg-[#CFA86A] selection:text-[#0A0D14]" data-id="element-342">
      <Hero data-id="element-343" />
      <FreeCardSection data-id="element-344" />
      <TarotExplanationSection data-id="element-345" />
      <TarotCardImage data-id="element-346" />
      <WhoIsThisFor data-id="element-347" />
      <PremiumBonusSection data-id="element-348" />
      <TestimonialsSection data-id="element-349" />
      <FoolCardImage data-id="element-350" />
      <StorySection data-id="element-351" />
      <SecretSectionTeaser data-id="element-352" />
      <EmotionalGuarantee data-id="element-353" />
      <CTASection data-id="element-354" />
      <LifestyleImage data-id="element-355" />
      <FAQSection data-id="element-356" />

      {/* Sales Notification - Mobile Only */}
      <SalesNotification data-id="element-357" />

      {/* Enhanced Footer */}
      <footer className="py-12 bg-[#0A0D14] border-t border-[#CFA86A]/10" data-id="element-358">
        <div className="max-w-4xl mx-auto px-4" data-id="element-359">
          {/* Icon */}
          <div className="flex justify-center mb-6" data-id="element-360">
            <Sparkles className="w-8 h-8 text-[#CFA86A] fill-[#CFA86A]" data-id="element-361" />
          </div>

          {/* Contact */}
          <div className="text-center mb-6" data-id="element-362">
            <p className="text-[#F7F5F2]/70 text-sm" data-id="element-363">
              Contacto 📩{' '}
              <a href="mailto:Myustra.info@gmail.com" className="text-[#CFA86A] hover:brightness-110 transition-all duration-300" data-id="element-364">
                Myustra.info@gmail.com
              </a>
            </p>
          </div>

          {/* Legal Links */}
          <div className="flex justify-center gap-6 mb-8 text-sm" data-id="element-365">
            <a href="#" className="text-[#F7F5F2]/60 hover:text-[#CFA86A] transition-colors duration-300" data-id="element-366">
              Política de Privacidad
            </a>
            <a href="#" className="text-[#F7F5F2]/60 hover:text-[#CFA86A] transition-colors duration-300" data-id="element-367">
              Términos y Condiciones
            </a>
            <a href="#" className="text-[#F7F5F2]/60 hover:text-[#CFA86A] transition-colors duration-300" data-id="element-368">
              FAQS
            </a>
          </div>

          {/* Legal Text */}
          <div className="text-center text-xs text-[#F7F5F2]/40 leading-relaxed max-w-2xl mx-auto" data-id="element-369">
            <p className="mb-2" data-id="element-370">
              © 2025 MisticaVibes. Todos los derechos reservados.
            </p>
            <p data-id="element-371">
              Este libro no predice tu futuro. Te enseña a construirlo desde tu
              claridad. Si atraviesas una crisis emocional, busca apoyo
              profesional.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}